export default __webpack_public_path__ + "static/SalesIntelligence_EasiestSetup_Small-Business_EaseOfSetup-c11c0b03a4e2f3aff132fa29a07d445e.svg";